import React from 'react';
import logotitle from './logotitle.png';

const Logo = ({ className = '' }) => {
  return (
    <div className={`logo-wrapper ${className}`}>
      <img 
        src={logotitle} 
        alt="CountyLee - Mileage Reimbursement Made Easy" 
        className="logo-image"
      />
    </div>
  );
};

export default Logo;

